import styled, { css } from 'styled-components';
import { SectionPlaceholderProps } from './types';
import { FlexBetween } from '../../../styled/common';
import { animation } from '../../../styled/placeholders.styled';

const placeholderRow = css`
  height: 15px;
  background-color: ${({ theme: { colors } }) => colors.background.secondary};
  border-radius: 4px;
`;

export const PlaceholderCardList = styled.div<SectionPlaceholderProps>`
  margin-top: 5px;
  display: flex;
  flex-flow: ${({ column }) => (column ? 'column' : 'row')};
  gap: 10px;

  & > div {
    width: 100%;
    margin-right: 0;
  }

  @media screen and (max-width: 315px) {
    & > :nth-child(n + 2) {
      display: none;
    }
  }

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    & > :nth-child(n + 3) {
      display: none;
    }
  }
  @media (min-width: ${({ theme }) =>
      theme.tabletBreakpoint}) and (max-width: ${({ theme }) =>
      theme.desktopBreakpoint}) {
    & > :nth-child(n + 4) {
      display: none;
    }
  }
  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    & > :nth-child(n + 5) {
      display: none;
    }
  }
`;

export const PlaceholderSection = styled.div<SectionPlaceholderProps>`
  margin-bottom: 10px;
  padding: 0 10px;
  background-color: ${({ white, theme: { colors } }) =>
    white ? colors.background.primary : 'transparent'};

  ${({ isCardsLayout }) =>
    isCardsLayout &&
    css`
      padding: 0 15px;

      ${PlaceholderCardList} {
        margin-top: 0;
      }

      @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
        padding: 0 40px;
      }
      @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
        padding: 0 20px;
      }
    `}
`;

export const PlaceholderSectionHeaderTitle = styled.div`
  width: 35%;
  height: 20px;
  ${placeholderRow};
  ${animation};
`;

export const PlaceholderSectionHeaderMore = styled.div`
  width: 10%;
  margin-top: 5px;
  ${placeholderRow};
  ${animation};
`;

export const PlaceholderSectionHeader = styled(
  FlexBetween
)<SectionPlaceholderProps>`
  height: 48px;
  padding: 14px 0;

  ${({ isCardsLayout }) =>
    isCardsLayout &&
    css`
      padding: 15px 0 0;
      height: 35px;
      margin-bottom: 15px;

      ${PlaceholderSectionHeaderTitle} {
        height: 20px;
      }

      ${PlaceholderSectionHeaderMore} {
        height: 20px;
      }

      @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
        height: 65px;
        padding: 15px 0;
      }

      @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
        ${PlaceholderSectionHeaderMore} {
          height: 30px;
        }
      }
    `}
`;
